import React, { Component } from "react";
import "./errorBoundry.scss";

export default class ErrorBoundry extends Component {
  state = {
    hasError: false
  };

  componentDidCatch() {
    this.setState({
      hasError: true
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error">
          <div className="error-title">something has gone terribly wrong</div>
          <div className="error-text">try reload the page</div>
        </div>
      );
    }
    return this.props.children;
  }
}
